/* The Veggie Patch: veggies are planted with only their tops showing. Tug one and it stretches, pops out of the soil
   with a spray of crumbs, lands with a squash and shows its tag. A second click opens it. Pull them all for a cheer. */
(function () {
  'use strict';
  var WH = window.WH;
  if (!WH) return;
  WH.register('patch', function (sec) {
    var plots = Array.prototype.slice.call(sec.querySelectorAll('[data-plot]'));
    var count = sec.querySelector('[data-patch-count]'), reset = sec.querySelector('[data-patch-reset]');
    var total = plots.length, up = 0;
    var BURY = 38;
    var parts = plots.map(function (p) { return { plot: p, btn: p.querySelector('[data-veg]'), body: p.querySelector('[data-veg-body]'), tag: p.querySelector('[data-veg-tag]') }; });
    if (window.gsap) gsap.set(parts.map(function (x) { return x.body; }), { y: 0, yPercent: BURY });

    function say() {
      if (!count) return;
      var tpl = count.getAttribute(up >= total ? 'data-done' : 'data-tpl');
      if (up === 0) { count.textContent = count.getAttribute('data-hint'); return; }
      count.textContent = (tpl || '').replace('[n]', up).replace('[t]', total);
    }
    function crumbs(plot) {
      if (!WH.anim) return;
      var r = plot.getBoundingClientRect(), y0 = r.height * 0.7;
      for (var i = 0; i < 9; i++) {
        var c = document.createElement('i');
        c.className = 'wh-crumb';
        c.style.left = (r.width * WH.rand(0.3, 0.7)) + 'px'; c.style.top = y0 + 'px';
        if (i % 3 === 0) c.style.background = '#8C5B36';
        plot.appendChild(c);
        var dx = WH.rand(-70, 70), up1 = WH.rand(40, 110);
        gsap.timeline({ onComplete: c.remove.bind(c) })
          .to(c, { x: dx * 0.6, y: -up1, rotation: WH.rand(-90, 90), duration: 0.3, ease: WH.sm('power2.out', 0.3) })
          .to(c, { x: dx, y: WH.rand(10, 30), duration: 0.4, ease: WH.sm('power2.in', 0.4) })
          .to(c, { opacity: 0, duration: 0.1 });
      }
    }
    function pull(x) {
      x.plot.classList.add('is-up');
      x.btn.setAttribute('aria-expanded', 'true');
      x.btn.setAttribute('aria-label', x.tag.querySelector('b').textContent + ', ' + x.tag.querySelector('span').textContent);
      x.tag.hidden = false;
      up++;
      say();
      WH.sound.play('rustle');
      if (!WH.anim) { gsap && gsap.set(x.body, { yPercent: 0 }); finish(); return; }
      gsap.timeline({ onComplete: finish })
        .to(x.body, { yPercent: BURY - 4, rotation: -5, duration: 0.09, ease: 'none' })
        .to(x.body, { yPercent: BURY - 2, rotation: 5, duration: 0.09, ease: 'none' })
        .to(x.body, { yPercent: BURY - 10, rotation: -3, scaleY: 1.22, scaleX: 0.9, duration: 0.17, ease: WH.sm('power1.in', 0.17) })
        .add(function () { crumbs(x.plot); WH.sound.play('pop'); })
        .to(x.body, { yPercent: -34, rotation: WH.rand(-16, 16), scaleY: 1.06, scaleX: 0.96, duration: 0.34, ease: WH.sm('power2.out', 0.34) })
        .to(x.body, { yPercent: -4, rotation: 0, scaleY: 1, scaleX: 1, duration: 0.25, ease: WH.sm('power2.in', 0.25) })
        .to(x.body, { scaleY: 0.86, scaleX: 1.12, duration: 0.09, ease: 'none' })
        .to(x.body, { yPercent: -6, scaleY: 1, scaleX: 1, duration: 0.25, ease: WH.sm('back.out(3)', 0.25) })
        .fromTo(x.tag, { scale: 0, rotation: -24 }, { scale: 1, rotation: -4, duration: 0.34, ease: WH.sm('back.out(2.6)', 0.34) }, '-=0.32');
    }
    function finish() {
      if (reset) reset.hidden = false;
      if (up >= total) cheer();
    }
    function cheer() {
      WH.sound.play('ding');
      if (!WH.anim) return;
      var r = sec.querySelector('.wh-patch__plots').getBoundingClientRect();
      for (var k = 0; k < 4; k++) WH.puff(r.left + r.width * (0.2 + k * 0.2), r.top + r.height * 0.3, 10, true);
      parts.forEach(function (x, i) {
        gsap.timeline({ delay: i * 0.08 })
          .to(x.body, { yPercent: -26, scaleY: 1.08, duration: 0.25, ease: WH.sm('power2.out', 0.25) })
          .to(x.body, { yPercent: -6, scaleY: 1, duration: 0.25, ease: WH.sm('power2.in', 0.25) });
      });
    }
    function replant() {
      up = 0; say();
      if (reset) reset.hidden = true;
      WH.sound.play('rustle');
      parts.forEach(function (x, i) {
        x.plot.classList.remove('is-up');
        x.btn.setAttribute('aria-expanded', 'false');
        x.btn.setAttribute('aria-label', x.btn.getAttribute('data-label'));
        var done = function () { x.tag.hidden = true; };
        if (!WH.anim) { gsap && gsap.set(x.body, { yPercent: BURY }); done(); return; }
        gsap.timeline({ delay: i * 0.06, onComplete: done })
          .to(x.tag, { scale: 0, duration: 0.17, ease: WH.sm('power1.in', 0.17) })
          .to(x.body, { yPercent: -16, duration: 0.17, ease: WH.sm('power1.out', 0.17) }, 0)
          .to(x.body, { yPercent: BURY, duration: 0.34, ease: WH.sm('power2.in', 0.34) });
      });
    }

    parts.forEach(function (x) {
      x.btn.setAttribute('data-label', x.btn.getAttribute('aria-label'));
      x.btn.addEventListener('click', function () {
        if (x.plot.classList.contains('is-up')) { window.location.href = x.tag.href; return; }
        pull(x);
      });
    });
    if (reset) reset.addEventListener('click', replant);
  });
})();
